import * as vfsFontsModule from 'pdfmake/build/vfs_fonts';

type VfsFonts = Record<string, string>;

type VfsFontsModule = {
  pdfMake?: { vfs: VfsFonts };
  default?: { pdfMake?: { vfs: VfsFonts } };
};

export function getPdfVfs(): VfsFonts | undefined {
  const mod = vfsFontsModule as unknown as VfsFontsModule;

  return (
    mod.pdfMake?.vfs ??
    mod.default?.pdfMake?.vfs ??
    (typeof window !== 'undefined'
      ? (window as unknown as { pdfMake?: { vfs: VfsFonts } }).pdfMake?.vfs
      : undefined)
  );
}
